import { defineMessages, useIntl } from "react-intl";
import SeoMetas from "./seo-metas";

const messages = defineMessages({
  aboutTitle: {
    id: "seo.editorial.about.title",
    defaultMessage: "Inter-Agence Nendaz | Agence immobilière locale"
  },
  aboutDescription: {
    id: "seo.editorial.about.description",
    defaultMessage: "Depuis plus de 50 ans, Inter-Agence accompagne vos projets immobiliers à Nendaz avec une approche humaine, locale et basée sur la confiance."
  },
  contactTitle: {
    id: "seo.editorial.contact.title",
    defaultMessage: "Contact Inter-Agence | Agence immobilière à Nendaz"
  },
  contactDescription: {
    id: "seo.editorial.contact.description",
    defaultMessage: "Contactez Inter-Agence à Nendaz pour vos projets immobiliers. Une équipe locale à votre écoute pour vous accompagner avec proximité et confiance."
  },
  estimationTitle: {
    id: "seo.editorial.estimation.title",
    defaultMessage: "Estimation immobilière à Nendaz | Inter-Agence"
  },
  estimationDescription: {
    id: "seo.editorial.estimation.description",
    defaultMessage: "Obtenez une estimation fiable de votre bien à Nendaz avec Inter-Agence. Analyse du marché local et accompagnement pour des décisions éclairées."
  },
  managementTitle: {
    id: "seo.editorial.management.title",
    defaultMessage: "Gérance immobilière à Nendaz | Inter-Agence"
  },
  managementDescription: {
    id: "seo.editorial.management.description",
    defaultMessage: "Confiez la gestion de votre bien à Nendaz à Inter-Agence. Suivi administratif, entretien et accompagnement local pour une gérance simple et sereine."
  },
  nendazTitle: {
    id: "seo.editorial.nendaz.title",
    defaultMessage: "Nendaz | Station alpine vivante au cœur du Valais"
  },
  nendazDescription: {
    id: "seo.editorial.nendaz.description",
    defaultMessage: "Découvrez Nendaz, station alpine du Valais, vivante toute l’année entre ski, nature, gastronomie et traditions locales, au cœur des Alpes."
  },
  newsTitle: {
    id: "seo.editorial.news.title",
    defaultMessage: "Actualités immobilières à Nendaz | Inter-Agence"
  },
  newsDescription: {
    id: "seo.editorial.news.description",
    defaultMessage: "Suivez les actualités immobilières à Nendaz avec Inter-Agence. Conseils, nouveautés et informations locales pour rester informé du marché."
  },
  renovationTitle: {
    id: "seo.editorial.renovation.title",
    defaultMessage: "Rénovation immobilière à Nendaz | Inter-Agence"
  },
  renovationDescription: {
    id: "seo.editorial.renovation.description",
    defaultMessage: "Rénovez votre bien à Nendaz avec Inter-Agence. Suivi structuré, coordination des travaux et partenaires fiables pour un projet mené sereinement."
  }
});

const pageMessages = {
  about: { title: messages.aboutTitle, description: messages.aboutDescription },
  contact: { title: messages.contactTitle, description: messages.contactDescription },
  estimation: { title: messages.estimationTitle, description: messages.estimationDescription },
  management: { title: messages.managementTitle, description: messages.managementDescription },
  nendaz: { title: messages.nendazTitle, description: messages.nendazDescription },
  news: { title: messages.newsTitle, description: messages.newsDescription },
  renovation: { title: messages.renovationTitle, description: messages.renovationDescription }
};

type EditorialPage = keyof typeof pageMessages;

const EditorialSeo = ({ page, seo }: { page: EditorialPage; seo?: Record<string, any> }) => {
  const intl = useIntl();
  const fallback = pageMessages[page];
  const cmsTitle = seo?.["seo-title"]?.trim();
  const cmsDescription = seo?.["seo-description"]?.trim();
  const keywords = typeof seo?.["seo-keywords"] === "string"
    ? seo["seo-keywords"].split(",").map((keyword: string) => keyword.trim()).filter(Boolean)
    : undefined;

  return (
    <SeoMetas title={cmsTitle || intl.formatMessage(fallback.title)}
              description={cmsDescription || intl.formatMessage(fallback.description)}
              keywords={keywords}
              image={seo?.["seo-image"]?.originalUrl} />
  );
};

export default EditorialSeo;
